acom_app.collections.Results = Backbone.Collection.extend({
    model: acom_app.models.Result
})